<template>
    <div id="perspective-first-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label">Задание перспективы</div>
        <div class="sidebar-text-area">Для начала работы выберите на рабочей области
            <span class="red-text bold-text">плоскость</span> для настройки. Чтобы приступить к заданию линий перспективы плоскости, воспользуйтесь кнопкой
        <span class="red-text bold-text">"Настроить перспективу"</span> на нижней панели.</div>
        <div class="sidebar-text-area">
            Альтернативно, Вы можете быстро перейти к настройкам перспективы, выбрав плоскость <span class="red-text bold-text">двойным кликом</span>.
        </div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/perspective_plane.png')"/>
        </div>
    </div>
</template>

<script>
    import {urlForStaticVue} from "../../common";

    export default {
        name: "PerspectiveInstructionsSidebarMenu",
        mixins: [urlForStaticVue]
    }
</script>

<style scoped>

</style>
